export interface ItalicAccentProps {
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

export function ItalicAccent({
	children,
	className,
	style,
}: ItalicAccentProps) {
	return (
		<span
			className={className}
			style={{
				fontFamily: "var(--font-display)",
				fontStyle: "italic",
				color: "var(--color-dashboard-accent-dark)",
				...style,
			}}
		>
			{children}
		</span>
	);
}
